"use client";

import React from "react";
import { Facebook, Instagram, MessageCircle, CreditCard, Wallet, Banknote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/ServicesPage" className="text-muted-foreground hover:text-primary transition-colors font-default">
            The Services
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/MembershipsPage" className="text-muted-foreground hover:text-primary transition-colors font-default">
            Memberships
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/ShopPage" className="text-muted-foreground hover:text-primary transition-colors font-default">
            Shop
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-default">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SariHutFooter() {
  return <section data-section-id="242163" id="footer" className="bg-card pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="inline-block">
              <span className="text-2xl font-default tracking-tighter text-foreground flex items-center !text-center">
                M <span className="text-[#8FA88F] font-bold text-3xl mx-1">/</span> O
              </span>
            </Link>
            <p className="mt-2 font-bold tracking-[0.3em] uppercase text-foreground/50 font-default !text-[8px]">Measure. Optimize. Perform. Maintain.</p>
            <p className="mt-6 text-muted-foreground font-default leading-relaxed max-w-sm">
              Setting the new standard in wellness with high-end medical and self-care services designed to optimize health, vitality, and performance across West Texas, the Dallas–Fort Worth area, and nationwide through virtual care.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 font-default">
              Quick Links
            </h3>
            <MenuProvider menu_id="24">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-6 font-default">West Texas + DFW Locations</h3>
            <p className="text-muted-foreground font-default mb-6">Visit our luxury wellness centers in Midland and Granbury. Follow us for wellness protocols and exclusive membership updates.</p>
            <div className="flex gap-4">
              <Link to="https://facebook.com" newTab className="bg-green-accent text-white p-2.5 rounded-full hover:bg-primary/90 transition-colors shadow-sm" aria-label="Facebook">
                <Facebook className="size-5 text-white" />
              </Link>
              <Link to="https://instagram.com" newTab className="bg-green-accent text-white p-2.5 rounded-full hover:bg-primary/90 transition-colors shadow-sm" aria-label="Instagram">
                <Instagram className="size-5 text-white" />
              </Link>
              <Link to="https://whatsapp.com" newTab className="bg-green-accent text-white p-2.5 rounded-full hover:bg-primary/90 transition-colors shadow-sm" aria-label="WhatsApp">
                <MessageCircle className="size-5 text-white" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="mb-8 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground font-default">
            &copy; {new Date().getFullYear()} MO Protocol. All rights reserved.
          </p>
          
          <div className="flex items-center gap-4 text-muted-foreground/40">
            <div className="flex items-center gap-1" title="Visa / Credit Card">
              <CreditCard className="size-6" />
            </div>
            <div className="flex items-center gap-1" title="Mobile Payments">
              <Wallet className="size-6" />
            </div>
            <div className="flex items-center gap-1" title="Secure Billing">
              <Banknote className="size-6" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}